export default {
  isLoading: false,
  data: {},
};
